import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface AddNewItemDialogData {
  itemName: string;
  itemGroupList: string[];
  userData?: any;
}

@Component({
  selector: 'app-add-new-item-dialog',
  templateUrl: './add-new-item-dialog.component.html',
  styleUrls: ['./add-new-item-dialog.component.scss']
})
export class AddNewItemDialogComponent {
  itemName: string = '';
  itemQuantity: string = '';
  itemGroupName: string = '';
  itemWhereToFindIt: string = '';
  imageUrl: string = '';
  saveToItemsList: boolean = true;
  saveToLibrary: boolean = false;
  itemGroupList: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddNewItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddNewItemDialogData
  ) {
    this.itemName = data.itemName || '';
    this.itemGroupList = data.itemGroupList || [];
    // Default to saving to library if user is logged in
    if (data.userData) {
      this.saveToLibrary = true;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.itemName.trim()) {
      this.dialogRef.close({
        itemName: this.itemName.trim(),
        itemQuantity: this.itemQuantity.trim(),
        itemGroupName: this.itemGroupName.trim(),
        itemWhereToFindIt: this.itemWhereToFindIt.trim(),
        imageUrl: this.imageUrl.trim(),
        saveToItemsList: this.saveToItemsList,
        saveToLibrary: this.saveToLibrary
      });
    }
  }

  onSelectItemGroup(event: any) {
    this.itemGroupName = event.option.value;
  }
}

